import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getForecastStatus = {
  name: "getForecastStatus" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    lastForecastAt: z.date().nullable(),
    isForecasting: z.boolean(),
    workflowStartTime: z.date().nullable(),
  }),
};
